import { ParsedUrlQuery } from 'querystring';
import { TFunction } from '@sortlist-frontend/translation/ssr';

import { getLocalizedUrl } from '_core/utils/public-links/getLocalizedUrl';
import { LinkStoriesDetails } from '_types/generic';
import { AnchorType, Business, Links, Person } from '_types/public-api';

export type StoryOptionType = 'all | client' | 'agency';
export type StoryOptionCountry = 'be' | 'fr' | 'nl' | 'es' | 'de';

export enum BusinessOptions {
  CATEGORY = 'type',
  COUNTRY = 'iso31661',
}

export const filteredStoriesLinks = (links: Links | undefined, type: string): LinkStoriesDetails[] | undefined => {
  if (links) {
    const filteredLinks = links.data
      .filter((data) => data.attributes.category.includes(type))
      .sort((a, b) => {
        if (a.attributes.position < b.attributes.position) return -1;
        else return 0;
      });

    return filteredLinks.map((link) => {
      const findRelation = links?.included.find((page) => page.id === link.relationships.to_page.data.id);
      const metadata = link.attributes.metadata;

      return {
        metadata,
        anchor: link.attributes.anchor,
        url: getLocalizedUrl({ ...findRelation?.attributes, link: findRelation?.attributes.path } as AnchorType),
        position: link.attributes.position,
      };
    });
  }

  return [] as LinkStoriesDetails[];
};

export type StoriesTypeProp = {
  key: string;
  label: string;
};

export const storiesType = (
  stories: LinkStoriesDetails[],
  t: TFunction,
  type: string,
  queryParams: ParsedUrlQuery,
): StoriesTypeProp[] | undefined => {
  const allLabel = t('stories:sorter.allSorter');
  if (stories.length > 0) {
    const optionType = type === 'type' ? 'category' : 'country';
    const defaultOption = queryParams[optionType]
      ? { key: queryParams[optionType], label: queryParams[optionType] }
      : { key: 'all', label: allLabel };

    const typeArr = stories.reduce(
      (acc: StoriesTypeProp[], story: LinkStoriesDetails) => {
        const response = story?.metadata?.business?.[type as keyof Business];
        response && acc.push({ key: response, label: response });
        return acc;
      },
      [{ ...defaultOption }, { key: 'all', label: allLabel }] as StoriesTypeProp[],
    );

    const finalResult = [] as StoriesTypeProp[];
    typeArr.forEach((item) => {
      if (finalResult.findIndex((x) => x.key === item.key) === -1) {
        finalResult.push(item);
      }
    });

    return finalResult;
  }
  return [];
};

export const titleCase = (string: string) => {
  if (string?.length > 0) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }
  return '';
};

const handleCountryName = (t: TFunction, iso: string) => {
  switch (iso) {
    case 'be':
      return t('stories:sorter.countryOptions.belgium');
    case 'de':
      return t('stories:sorter.countryOptions.germany');
    case 'fr':
      return t('stories:sorter.countryOptions.france');
    case 'nl':
      return t('stories:sorter.countryOptions.netherlands');
    case 'es':
      return t('stories:sorter.countryOptions.spain');
    default:
      return t('stories:sorter.allSorter');
  }
};
